import { useLocalStorage } from '@vueuse/core';

interface User {
  uuid: string;
  email: string;
  isAdmin: boolean;
  lastName: string;
  isActive: boolean;
  firstName: string;
  updatedAt: string;
  createdAt: string;
  isSuperuser: boolean;
  companyId: string | null;
}

export const useUserStore = defineStore('user', () => {
  const user = useLocalStorage<User | null>('user', () => null, {
    serializer: {
      write: (v: any) => JSON.stringify(v),
      read: (v: any) => v ? JSON.parse(v) : null,
    },
  });

  const { $sellebrate } = useNuxtApp();

  const fetchMe = async () => {
    const me = await $sellebrate<User>('/users/me');
    user.value = me;
    return me;
  };

  return { user, fetchMe };
});
